import { render } from "./OurShop.vue?vue&type=template&id=736875b6&scoped=true"
import script from "./OurShop.vue?vue&type=script&lang=js"
export * from "./OurShop.vue?vue&type=script&lang=js"

import "./OurShop.vue?vue&type=style&index=0&id=736875b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736875b6"]])

export default __exports__